import React from 'react';
import PropTypes from 'prop-types';
import {Table, TableFilterRow} from '@devexpress/dx-react-grid-material-ui';

export const ColumnDefinedFilterCell = (props) => {
  const {
    column: {
      CustomCellFilterComponent = TableFilterRow.Cell,
      customCellFilterProps = {},
    },
  } = props;

  return CustomCellFilterComponent ? (
    <CustomCellFilterComponent {...customCellFilterProps} {...props} />
  ) : (
    <Table.StubHeaderCell />
  );
};

ColumnDefinedFilterCell.propTypes = {
  column: PropTypes.shape({
    CustomCellFilterComponent: PropTypes.oneOfType([
      PropTypes.func,
      PropTypes.bool,
    ]),
    // eslint-disable-next-line react/forbid-prop-types
    customCellFilterProps: PropTypes.object,
  }).isRequired,
};
